const initOtherProductsBlock = async () => {
    const debounce = (fn, ms = 150) => {
        let t;
        return (...a) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...a), ms);
        };
    };

    const syncTitleHeights = (root) => {
        if (!root) return;
        const titles = root.querySelectorAll('.product_card h4');
        if (!titles.length) return;

        titles.forEach(t => t.style.removeProperty('min-height'));

        let maxLines = 1;
        let maxLineHeight = 0;

        titles.forEach(t => {
            const cs = getComputedStyle(t);
            let lh = parseFloat(cs.lineHeight);
            if (!lh || Number.isNaN(lh)) {
                lh = parseFloat(cs.fontSize) * 1.2;
            }
            const h = t.getBoundingClientRect().height;
            if (lh > maxLineHeight) maxLineHeight = lh;
            const lines = Math.round(h / lh);
            if (lines > maxLines) maxLines = lines;
        });

        const minH = (maxLineHeight * maxLines) + 'px';
        titles.forEach(t => { t.style.minHeight = minH; });
    };

    const setupBlock = async () => {
        const container = document.querySelector('.other-products-section');
        if (!container) return;

        syncTitleHeights(container);

        if (!container.dataset.titleSyncBound) {
            container.dataset.titleSyncBound = '1';

            const onResize = debounce(() => syncTitleHeights(container), 150);
            window.addEventListener('resize', onResize);

            const ro = new ResizeObserver(debounce(() => syncTitleHeights(container), 100));
            ro.observe(container);

            const mo = new MutationObserver(debounce(() => syncTitleHeights(container), 100));
            mo.observe(container, { childList: true, subtree: true, characterData: true });
        }
    };

    const container = document.querySelector('.other-products-section');
    if (container) {
        setupBlock();
        return;
    }

    const observer = new MutationObserver((mutations, obs) => {
        const c = document.querySelector('.other-products-section');
        if (c) {
            obs.disconnect();
            setupBlock();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};

document.addEventListener("DOMContentLoaded", initOtherProductsBlock);